
import { defineComponent, computed } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  setup() {
    const { state, dispatch } = useStore()
    const carNumber = computed(() => state.autocall.carNumber)
    const checkCarNumber = () => dispatch("autocall/checkCarNumber", carNumber.value)
    return {
      checkCarNumber,
      carNumber,
    }
  },
})
